import { createSlice } from '@reduxjs/toolkit';
import {
  createPfLoan,
  fetchAllPfLoans,
  fetchPfLoanById,
  updatePfLoan,
  deletePfLoan
} from './pfLoanActions';
import { PfLoanState } from './pfLoanTypes';

const initialState: PfLoanState = {
  records: [],
  selectedRecord: undefined,
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    update: false,
    delete: false
  },
  errors: {}
};

const pfLoanSlice = createSlice({
  name: 'pfLoan',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createPfLoan.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createPfLoan.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.records.push(action.payload.data);
      })
      .addCase(createPfLoan.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllPfLoans.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllPfLoans.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.records = action.payload.data;
      })
      .addCase(fetchAllPfLoans.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchPfLoanById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchPfLoanById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedRecord = action.payload.data;
      })
      .addCase(fetchPfLoanById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updatePfLoan.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updatePfLoan.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.records.findIndex(
          (rec) => rec.pfLoanId === action.payload.id
        );
        if (index !== -1) {
          state.records[index] = {
            ...action.payload.data,
            pfLoanId: action.payload.id
          };
        }
      })
      .addCase(updatePfLoan.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

      // Delete
      .addCase(deletePfLoan.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deletePfLoan.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.records = state.records.filter(
          (record) => record.pfLoanId !== action.payload
        );
      })
      .addCase(deletePfLoan.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      });
  }
});

export default pfLoanSlice.reducer;
